import React, { useEffect, useState } from "react";
import i18n from "../../../i18n/i18n";
import { Button } from "react-bootstrap";
import { Drawer, Table, TableColumnsType } from "antd";
import {deleteMaterialTypeById, getMaterialTypeById, getMaterialTypeList } from "./core/_request";
import { initialMaterialTypePageState, MaterialTypeItemData, MaterialTypePageState } from "./core/_model";
import MaterialTypeForm from "./MaterialTypeForm";
import { useMaterialTypeListState, useMaterialTypeStore } from "./store/MaterialTypeStore";
import Actions from "../../../common/components/Actions/Actions";
import { ActionsKey } from "../../../common/models/Actions";
import LFTable from "../../../common/components/LFTable/LFTable";
import { ColumnItem } from "../../../common/models/table";
import { BsFiletypeXls } from "react-icons/bs";
import useAppStore from "../../../store/AppStore";
import { toast } from "sonner";
import { API_URLs } from "../../../utilities/API_URLs";
import Cookies from "universal-cookie";
import { API_BASE_URL_IMAGE } from "../../../utilities/API_CONSTANT";

const MaterialTypeList = () => {
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [sort, setSort] = useState<any>(null);
  const {activeMenu} = useAppStore()
  const { pageState, setPageState } = useMaterialTypeListState();
  const { materialTypeList, setMaterialTypeList, actioned, setActioned } = useMaterialTypeStore();
  const onSavedMaterialType = (access: any) => {
    setOpenForm(false);
    setPageState(initialMaterialTypePageState);
    refreshMaterialTypeList()
    setActioned(null)
  };
  const refreshMaterialTypeList = async (newState?: MaterialTypePageState) => {
    const list = await getMaterialTypeList(newState ?? initialMaterialTypePageState);
    if (list) {
      setMaterialTypeList(list);
    }
  };
  const loadMaterialTypeById = async (mat: MaterialTypeItemData, action: ActionsKey) => {
    const mt = await getMaterialTypeById(mat?.id?.toString())
    if (mt) {
      setActioned({data: mt, action})
    }
  }
  const onDeleteMaterialTypeById = async (mat: MaterialTypeItemData) => {
    const deleteResponse = await deleteMaterialTypeById(mat?.id?.toString())
    if (deleteResponse && deleteResponse?.success) {
      toast.success('Type de matériel supprimé avec succès')
    } else {
      toast.error('Une erreur de suppresion du type de matériel')
    }
    refreshMaterialTypeList()
  }
  const onActionClick = (user: MaterialTypeItemData, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteMaterialTypeById(user);
    } else {
      loadMaterialTypeById(user, action);
    }
  };
  const downloadAsExcel = () => {
    // const p: Array<any> = [];
    let pars = "?";
    columns?.forEach((c, ik) => {
      if (c.show) {
        pars += c.nestedKey
        ? c.nestedKeyAsParam + "&"
        : "p[]=" + (c.dataIndex ?? "") + (ik < columns.length - 1 ? "&" : "&");
      }
    });
    const url =
      API_URLs.settings.materialType.getMaterialTypes + ".global-listing-spreadsheet" + pars;
    const cookies = new Cookies(document.cookie, { path: "/" });
    const authorizationData = cookies.get("auth_data");
    let headers: any = null;
    if (authorizationData) {
      headers = {
        Authorization: "Bearer " + authorizationData.token,
      };
    }
    fetch(API_BASE_URL_IMAGE + url, {
      method: "GET",
      headers: headers,
    })
      .then((res) => res.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `sems-type-materiel.xlsx`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link?.parentNode?.removeChild(link);
      });
  };
  useEffect(() => {
    let newState = {...pageState, order: sort ?? {dataKey: 'id', order: 'desc'}}
    setPageState(newState)
    refreshMaterialTypeList(newState)
  }, [sort])
  const cols: ColumnItem[] = [
    {
      key: "name",
      title: "Matériel",
      dataIndex: "name",
      show: true,
    },
  ];
  const [columns, setColumns] = useState<any[]>(cols)
  return (
    <div>
      <div className="d-flex justify-content-between p-4">
        <h4>{activeMenu?.title}</h4>
        <div className="d-flex">
          {/* <div className="m-1 p-1 cursor-pointer">
            <BiSolidFileImport size={20} />
          </div> */}
          <div className="m-1 p-1 cursor-pointer" onClick={downloadAsExcel}>
            <BsFiletypeXls size={20} />
          </div>
          <Button
            className="text-white btn-primary"
            onClick={() => setOpenForm(true)}
          >
            {i18n.t("NEW")}
          </Button>
        </div>
      </div>
      <div className="p-4">
        {/* <Table
          columns={coumns}
          dataSource={materialTypeList?.member}
          className=""
          rowClassName={(r) => {
            return r?.id % 2 === 0 ? "table-row-c2" : "table-row-c1";
          }}
          locale={{
            emptyText: "Aucune donnée"
          }}
        /> */}
        <LFTable
          columns={columns}
          data={materialTypeList?.member as any}
          onAction={onActionClick}
          onChangeColumns={(cols) => {
            setColumns(cols)
          }}
          permissions={["read", "update", "delete"]}
          // exceptions={{
          //   update: { key: "userRole.@id", value: "/api/user_roles/1" },
          //   delete: { key: "userRole.@id", value: "/api/user_roles/1" },
          //   no: null,
          //   read: null,
          // }}
          onSearch={(search) => {
            let newState = {...pageState, [search.dataKey]: search.searchStr}
            setPageState(newState)
            refreshMaterialTypeList(newState)
          }}
          onSort={(sort) => {
            setSort(sort)
          }}
          sort={sort}
          onResetSearch={() => {
            const newState = {...pageState, name: ''}
            setPageState(newState)
            refreshMaterialTypeList(newState)
          }}
        />
      </div>
      <Drawer
        open={openForm || actioned !== null}
        placement="right"
        onClose={() => {
          setOpenForm(false)
          setActioned(null)
        }}
        width={"75%"}
        title={actioned?.action === 'read' ? 'Détails' : actioned?.action === 'update' ? 'Modification' : i18n.t("NEW")}
      >
        <MaterialTypeForm onCreated={onSavedMaterialType} actioned={actioned} open={openForm || actioned !== null} />
      </Drawer>
    </div>
  );
};

export default MaterialTypeList;
